import React from "react";

import { Modal } from "react-bootstrap";

import { LoadingPage } from "../common/loading";
import { commonErr } from "../common/errors";
import { MessageBox, Empty } from "../common/messagebox";

import { getListCard, requestAddCard, removeCard } from "../../model/payment";

import { IcTrash, IcPlusS, IcPlusCircle } from "../common/svg";

import credit_card from "../../static/images/cards-type/mastercard.svg";
import visa from "../../static/images/cards-type/visa.svg";
import master from "../../static/images/cards-type/mastercard.svg";
import jcb from "../../static/images/cards-type/jcb.svg";

import empty from "../../static/images/cards-type/my-card.svg";

const ConfirmRemove = ({ show, onHide, errMsg, removeCard }) => {
	return (
		<Modal show={show} onHide={onHide} dialogClassName="modal-s modal-confirm">
			<Modal.Header closeButton={true} closeLabel={""}>
				<h5>Xác nhận xoá thẻ</h5>
			</Modal.Header>
			<Modal.Body>
				<div className="modal-confirm-body">
					{!errMsg || errMsg === "" ? (
						<p className="font-14">Bạn có chắc là muốn hủy liên kết với thẻ này?</p>
					) : errMsg !== "" ? (
						<p>{errMsg}</p>
					) : null}
					<div className="wrap-btn has-2-btn">
						<a className="btn btn--m btn-primary" onClick={removeCard}>
							Xóa
						</a>
						<a className="btn btn-link" onClick={onHide}>
							Bỏ qua
						</a>
					</div>
				</div>
			</Modal.Body>
		</Modal>
	);
};

class CardItem extends React.Component {
	constructor(props) {
		super(props);
	}
	buildImgPayment = () => {
		const cardBrand = this.props.card.cardBrand;
		switch (cardBrand) {
			case "VISA":
				return <img loading="lazy" src={visa} />;
			case "MASTERCARD":
				return <img loading="lazy" src={master} />;
			case "JCB":
				return <img loading="lazy" src={jcb} />;
			default:
				return <img loading="lazy" src={credit_card} />;
		}
	};

	render() {
		const { card } = this.props;
		return (
			<div className="card-item">
				<div className="logo-edit">
					<div className="logo">{this.buildImgPayment()}</div>
					{card.cardType && (
						<div className="edit" style={{ textTransform: "uppercase" }}>
							{card.cardType}
						</div>
					)}
				</div>
				<div className="number-name">
					<p className="number">•••• •••• •••• {card.cardNumber.slice(12)}</p>
					<p className="name">{card.cardName}</p>
				</div>
				<div className="date-remove">
					<p className="date">
						{card.cardExpiredMonth}/{card.cardExpiredYear}
					</p>
					<div
						className="wrap-svg remove"
						onClick={() => {
							this.props.showConfirmRemove(card.cardId);
						}}>
						<IcTrash />
					</div>
				</div>
			</div>
		);
	}
}

{
	/* <div className="info-card">
				<p className="card-number">•••• •••• •••• {card.cardNumber.slice(12)}
					{card.cardType && <span className="card-type" style={{ textTransform: "uppercase" }}>{card.cardType}</span>}
				</p>
				<p className="card-name" >{card.cardName}</p>
				<p className="valid-card">Hiệu lực thẻ: {card.cardExpiredMonth}/{card.cardExpiredYear}</p>
			</div>
			<div className="remove-card">
				<a className="btn btn--m btn-secondary hide-on-sm" onClick={() => { props.showConfirmRemove(card.cardId) }}>Hủy liên kết thẻ</a>
			</div> */
}

export default class MyCard extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			cards: [],
			activeCarId: 0,
			isShowConfirmRemove: false,
		};
	}
	componentDidMount() {
		window.scrollTo(0, 0);

		this.setState({
			err: commonErr.LOADING,
		});

		getListCard().then((myCardResp) => {
			if (myCardResp.data.error >= commonErr.SUCCESS && myCardResp.data.data) {
				this.setState({
					err: myCardResp.data.error,
					cards: myCardResp.data.data,
				});
			} else {
				this.setState({
					err: myCardResp.data.error,
					cards: null,
				});
			}
		});
	}
	componentDidUpdate(props) {
		if (props.cards && props.cards.length != this.props.cards.length) {
			this.setState({
				cards: this.props.cards,
			});
		}
	}

	onAddCardBtn = (callbackPaths) => {
		// this.setState({
		// 	err: commonErr.LOADING
		// });

		requestAddCard(callbackPaths).then((cardResp) => {
			const { data, error, errorMessage } = cardResp.data;
			if (error >= commonErr.SUCCESS && data) {
				window.location.assign(data.linkUrl);
			} else {
				this.setState({
					err: error,
					errMsg: errorMessage,
				});
			}
		});
	};

	showConfirmRemove = (cardId) => {
		this.setState({
			isShowConfirmRemove: true,
			activeCardId: cardId,
		});
	};

	hideConfirmRemove = () => {
		this.setState({
			activeCarId: 0,
			err: commonErr.INNIT,
			errMsg: "",
			isShowConfirmRemove: false,
		});
	};

	removeCard = () => {
		this.setState({
			err: commonErr.LOADING,
		});

		removeCard(this.state.activeCardId).then((resp) => {
			if (resp.data.error >= commonErr.SUCCESS) {
				getListCard().then((myCardResp) => {
					if (myCardResp.data.error >= commonErr.SUCCESS && myCardResp.data.data.length > 0) {
						this.setState({
							err: myCardResp.data.error,
							cards: myCardResp.data.data,
							isShowConfirmRemove: false,
							activeCarId: 0,
						});
					} else {
						this.setState({
							err: myCardResp.data.error,
							cards: null,
							isShowConfirmRemove: false,
							activeCarId: 0,
						});
					}
				});
			} else {
				this.setState({
					err: resp.data.error,
					errMsg: resp.data.errorMessage,
				});
			}
		});
	};

	hideMessageBox = () => {
		this.setState({
			err: commonErr.INNIT,
			errMsg: "",
		});
	};

	onAddCart = () => {
		if (this.props.profile.info.emailVerified) {
			const path = "mycard";
			this.onAddCardBtn(path);
		} else {
			this.setState({
				err: commonErr.FAIL,
				errMsg: "Bạn cần xác thực email để thêm thẻ",
			});
		}
	};

	render() {
		var content;

		const { err, errMsg, cards, isShowConfirmRemove } = this.state;
		const { profile } = this.props;

		if (err === commonErr.LOADING) {
			content = <LoadingPage />;
		} else if (err >= commonErr.SUCCESS && cards && cards.length > 0) {
			content = (
				<div className="content">
					{cards.map((card) => (
						<CardItem key={card.cardId} card={card} showConfirmRemove={this.showConfirmRemove}></CardItem>
					))}
				</div>
			);
		} else {
			content = <Empty img={empty} msg={"Bạn chưa có thẻ nào"} />;
		}

		return (
			<div className="content-item my-cards">
				<div className="title">
					<h6>Thẻ của tôi</h6>
					<a className="btn btn--s" onClick={this.onAddCart}>
						Thêm thẻ
						<div className="wrap-svg">
							<IcPlusCircle />
						</div>
					</a>
				</div>

				{content}

				<MessageBox show={errMsg !== ""} error={err} message={errMsg} hideModal={this.hideMessageBox} />
				<ConfirmRemove
					errMsg={errMsg}
					show={isShowConfirmRemove}
					onHide={this.hideConfirmRemove}
					removeCard={this.removeCard}
				/>
			</div>
		);
	}
}
